import React from 'react';

interface PageIconProps {
  Icon: React.FC<{ className?: string }>;
}

export const PageIcon: React.FC<PageIconProps> = ({ Icon }) => {
  return <Icon className="inline w-10 h-10 mr-2 -mb-1 text-gray-500" />;
};

export default PageIcon;
